import { ilerp, lerp, lerpLerp } from "../../../core/util/MathUtil";
import { rUniform } from "../../../core/util/Random";

/**
 * Create a noise source node with shaped noise for a metallic character.
 */
export function createNoiseSource(
  audioContext: AudioContext,
  { length = 1 }: { length?: number },
): AudioBufferSourceNode {
  const buffer = audioContext.createBuffer(
    1,
    audioContext.sampleRate * length,
    audioContext.sampleRate,
  );
  const data = buffer.getChannelData(0);
  for (let i = 0; i < data.length; i++) {
    data[i] = rUniform(-1, 1);
  }
  const source = audioContext.createBufferSource();
  source.buffer = buffer;
  source.loop = true;
  return source;
}

export function createDistortionNode(
  audioContext: AudioContext,
  f: (x: number) => number,
): WaveShaperNode {
  const distortion = audioContext.createWaveShaper();
  const curve = new Float32Array(256);
  for (let i = 0; i < curve.length; i++) {
    const x = lerpLerp([0, curve.length - 1], [-1, 1], i);
    curve[i] = f(x);
  }
  distortion.curve = curve;
  return distortion;
}
